import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import { VaultItemDTO } from '../../types';
import { createParchmentSurface, hashStringToSeed } from '../../theme/surfaces';
import { GrimoireCard } from './GrimoireCard';

interface GrimoireMiniCardProps {
  item: VaultItemDTO;
  memberNameById: Map<string, string>;
  onDiscard: (instanceId: string) => void;
  onSell?: (instanceId: string) => void;
}

export const GrimoireMiniCard: React.FC<GrimoireMiniCardProps> = React.memo(function GrimoireMiniCard({
  item,
  memberNameById,
  onDiscard,
  onSell,
}) {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const surfaceSx = React.useMemo(
    () => createParchmentSurface(hashStringToSeed(item.id)),
    [item.id],
  );

  return (
    <Box sx={{ ...surfaceSx, width: 270 }} p={1.5}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 0.5 }}>
        <Typography variant="subtitle2">{item.name}</Typography>
        <IconButton size="small" onClick={() => setIsExpanded(true)} aria-label={`Expand ${item.name}`}>
          <OpenInFullIcon fontSize="inherit" />
        </IconButton>
      </Box>
      <Dialog open={isExpanded} onClose={() => setIsExpanded(false)} maxWidth="sm" className="MemberDialog" sx={{ m: 0, p: 0, border: 0 }}>
        <DialogContent sx={{ m: 1, p: 0 }}>
          <GrimoireCard
            item={item}
            memberNameById={memberNameById}
            onDiscard={(instanceId) => { setIsExpanded(false); onDiscard(instanceId); }}
            onSell={onSell}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsExpanded(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
});
